import { type ReactNode, useState } from "react";
import { Icon, type IconName } from "../Icon";
import { Text } from "../Text";
import { DefaultIcon, HoverIcon, ToggleIconContainer } from "../ToggleIcon";
import {
  CollapsibleHeader,
  CollapsibleHeaderInner,
  ExpandedContent,
  ExpandInner,
  ExpandWrapper,
} from "./Expand";

export const kickoffDisplay = {
  autofix: { icon: "radar", label: "Autofix kickoff" },
  autotune: { icon: "audio-waveform", label: "Autotune kickoff" },
  sub_agent: { icon: "ask", label: "Chat kickoff" },
  search: { icon: "search", label: "Search request" },
} satisfies Record<string, { icon: IconName; label: string }>;

export function KickoffMessage({
  text,
  icon,
  label,
  children,
}: {
  text: string;
  icon: IconName;
  label: string;
  children?: ReactNode;
}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: expanded ? 2 : 0,
      }}
    >
      <CollapsibleHeader
        aria-expanded={expanded}
        onPress={() => setExpanded((prev) => !prev)}
      >
        <CollapsibleHeaderInner>
          <ToggleIconContainer aria-hidden>
            <DefaultIcon>
              <Icon name={icon} size={12} color="var(--text-secondary)" />
            </DefaultIcon>
            <HoverIcon>
              <Icon
                name={expanded ? "minus" : "plus"}
                size={12}
                color="var(--text-secondary)"
              />
            </HoverIcon>
          </ToggleIconContainer>
          <Text variant="text-small" color="var(--text-secondary)">
            {label}
          </Text>
        </CollapsibleHeaderInner>
      </CollapsibleHeader>
      <ExpandWrapper data-expanded={expanded} inert={!expanded}>
        <ExpandInner data-expanded={expanded}>
          <ExpandedContent>
            {children}
            <Text variant="text-small" color="var(--text-secondary)">
              <span style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {text}
              </span>
            </Text>
          </ExpandedContent>
        </ExpandInner>
      </ExpandWrapper>
    </div>
  );
}
